import { render, staticRenderFns } from "./patient-prescr-monitoring-table.vue?vue&type=template&id=1e70f16e&scoped=true&lang=pug&"
import script from "./patient-prescr-monitoring-table.vue?vue&type=script&lang=ts&"
export * from "./patient-prescr-monitoring-table.vue?vue&type=script&lang=ts&"
import style0 from "./patient-prescr-monitoring-table.vue?vue&type=style&index=0&id=1e70f16e&scoped=true&lang=css&"
import style1 from "./patient-prescr-monitoring-table.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e70f16e",
  null
  
)

export default component.exports